import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Eye, EyeClosed } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import './Auth.css';

const SignUp = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const navigate = useNavigate();
  const { signUp, signInWithGoogle } = useAuth();

  const handleSignUp = async (e) => {
    e.preventDefault();
    setError('');
    setSuccessMessage('');

    setIsLoading(true);
    try {
      const { user, session } = await signUp(email, password);
      
      if (user && !session) {
        // Email confirmation required
        setSuccessMessage('Please check your email for confirmation link');
      } else {
        // Auto-confirmed, redirect to home
        navigate('/');
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleGoogleSignUp = async () => {
    try {
      await signInWithGoogle();
      // Google OAuth will handle the redirect
    } catch (error) {
      setError(error.message);
    }
  };

  if (successMessage) {
    return (
      <div className="auth-container" data-auth="signup" style={{ backgroundImage: "linear-gradient(rgba(255,255,255,0.6), rgba(255,255,255,0.6)), url('/background.png')", backgroundRepeat: 'repeat', backgroundSize: '450px 300px' }}>
        <div className="auth-card">
          <div className="auth-logo">
            <h1>SuperTask</h1>
          </div>
          
          <div className="auth-message">
            <h2>Check your email</h2>
            <p>{successMessage}</p>
            <Link to="/signin" className="auth-button primary">
              Return to Sign In
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container" data-auth="signup" style={{ backgroundImage: "linear-gradient(rgba(255,255,255,0.6), rgba(255,255,255,0.6)), url('/background.png')", backgroundRepeat: 'repeat', backgroundSize: '450px 300px' }}>
      <div className="auth-card">
        <div className="auth-logo">
          <h1>SuperTask</h1>
        </div>

        {error && (
          <div className="auth-error">
            {error}
          </div>
        )}

        <form onSubmit={handleSignUp} className="auth-form">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="j@schnarr.com"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <div className="password-input">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <Eye size={20} /> : <EyeClosed size={20} />}
              </button>
            </div>
          </div>

          <div className="auth-button-container">
            <button 
              type="submit" 
              className="auth-button primary"
              disabled={isLoading}
            >
              {isLoading ? 'Creating Account...' : 'Create Account'}
            </button>

            <div className="auth-divider">
              <span>OR</span>
            </div>

            <button
              type="button"
              className="auth-button google"
              onClick={handleGoogleSignUp}
              disabled={true}
              style={{ opacity: 0.7, cursor: 'not-allowed' }}
              title="Coming soon!"
            >
              <img src="/google-icon.svg" alt="Google" />
              Continue with Google (Coming Soon)
            </button>

            <p className="auth-footer">
              Already have an account?{' '}
              <Link to="/signin" className="auth-link">
                Sign in
              </Link>
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SignUp; 